import { useRef } from 'react';
import classnames from 'classnames';

import { useHistory } from 'react-router-dom';

import { useMedia, useFadeIn } from 'utils/hooks';

import { useModal } from 'models/modal';
import { useAuth } from 'models/auth';
import { useTransition } from 'models/mainSite';
import { useUserData } from 'models/user';

import ButtonUI from 'components/atoms/ButtonUI';

import gift from 'images/icons/gift.png';
import recommand from 'images/icons/recommand.png';
import explore from 'images/icons/explore-icon.png';
import rank from 'images/icons/rank.png';

import styles from './index.css';

export interface UserControlRightProp {
    className?: string;
}

const UserControlRight: React.FC<UserControlRightProp> = ({ className }) => {
    const ref = useRef(null);
    const [, { openModal }] = useModal();
    const [, { startTransition }] = useTransition();
    const [{ loginType }] = useAuth();
    const [{ redeemPoints, totalPoints }] = useUserData();

    const media = useMedia();

    const {
        location: { pathname },
    } = useHistory();

    useFadeIn([{ ref }]);

    return (
        <div ref={ref} className={classnames(styles.userControlRight, className)}>
            {pathname.includes('/town') && (
                <ButtonUI
                    className={styles.button}
                    icon={recommand}
                    text="推薦參觀"
                    onClick={() => {
                        if (loginType === 'facebook') {
                            openModal({
                                type: 'recommend',
                            });
                        } else {
                            openModal({
                                type: 'needLogin',
                            });
                        }
                    }}
                    shadow
                />
            )}
            {!pathname.includes('/town') && !pathname.includes('/en') && (
                <ButtonUI
                    className={styles.button}
                    icon={explore}
                    text="返回"
                    onClick={() => {
                        startTransition({ nextPath: '/town' });
                    }}
                    shadow
                />
            )}
            <ButtonUI
                className={classnames(styles.button, styles.menu)}
                text={!pathname.includes('/en') ? '菜單' : 'MENU'}
                onClick={() => {
                    openModal({
                        type: 'menu',
                    });
                }}
                shadow
            >
                <div className={styles.barWrapper}>
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                </div>
            </ButtonUI>
            {media === 'phone' && (
                <div className={styles.vertical}>
                    <ButtonUI
                        className={styles.button}
                        icon={gift}
                        onClick={() => {
                            if (loginType === 'facebook') {
                                openModal({
                                    type: 'userPoints',
                                });
                            } else {
                                openModal({
                                    type: 'needLogin',
                                });
                            }
                        }}
                        small
                        shadow
                        notification={Math.floor(totalPoints / 1000) > redeemPoints.length}
                    />
                    <ButtonUI
                        className={styles.button}
                        icon={rank}
                        onClick={() => {
                            openModal({
                                type: 'rank',
                            });
                        }}
                        small
                        shadow
                    />
                </div>
            )}
        </div>
    );
};

export default UserControlRight;
